import React from 'react';
import { connect } from 'react-redux'
import { Tooltip, parseJSON, Spinner, formatMoney } from '../../utils'
import CurrencyFormat from 'react-currency-format';
import ReactSlider from 'react-slider'

import moment from 'moment'

const GESTable = {
    5: 60.4350,
    6: 73.8250,
    7: 87.5150,
    8: 101.5050,
    9: 115.7950,
    10: 133.2150,
    11: 148.1650,
    12: 163.4400,
    13: 179.0350,
    14: 194.9750,
    15: 211.2150,
    16: 227.7850,
    17: 244.6850,
    18: 261.9200,
    19: 280.0000,
    20: 298.5100,
    21: 317.4500,
    22: 337.5350,
    23: 358.1550,
    24: 379.3300,
    25: 401.0650,
    26: 423.3800,
    27: 446.2850,
    28: 469.8000,
    29: 493.9350,
    30: 518.7050,
    31: 544.1300,
    32: 570.2150,
    33: 596.9900,
    34: 624.4650,
    35: 652.6550,
    36: 681.5800,
    37: 711.2550,
    38: 741.7050,
    39: 772.9450,
    40: 804.9950,
    41: 837.8700,
    42: 871.5950,
    43: 906.1850,
    44: 941.6700,
    45: 978.0650,
    46: 1015.4000,
    47: 1053.6850,
    48: 1092.9550,
    49: 1133.2300,
    50: 1174.5350,
}


class VidCalculatorPublic extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showResults: false,
            rate: null,
            isFetching: false,
            year: 5,
            totalYears: 30,
            endAge: 67,
            conversionValue: null,
            startingSalary: props.startingSalary,
            contractType: props.contractType,
            employerContribution: props.employerContribution,
            customTooltip: props.customTooltip,
            errors: [],
            fetchError: ''
        }

        this.startingAge = React.createRef();
        this.startingSalary = React.createRef();

        this.calculate = this.calculate.bind(this)
        this.fetchData = this.fetchData.bind(this)
        this.calculateOffset = this.calculateOffset.bind(this)
        this.calculateArrowOffset = this.calculateArrowOffset.bind(this)
        this.updateOffset = this.updateOffset.bind(this)
        this.calculateWaiting = this.calculateWaiting.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {
        $(window).on('resize', () => {
            this.updateOffset()
        })
    }

    fetchData() {
        this.setState({ isFetching: true })

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
        let contractType = this.state.contractType
        let startingAge = this.startingAge.current.value
        let startingSalary = this.state.startingSalary


        fetch(`/data/calculators/vid/?salary_isk=${startingSalary}&employer_contribution=${this.state.employerContribution}&start_age=${startingAge}&end_age=${this.state.endAge}`, {
            headers: headers,
            credentials: 'include',
        })
            .then(response => {
                if (response.ok) {
                    return response
                } else {
                    this.setState({ fetchError: 'Ekki var hægt að framkalla útreikning. Við bjóðum þér að hafa samband við okkur ef þú vilt skoða málið frekar með því að panta ráðgjöf.' })
                    this.updateOffset()
                    $(window).scrollTop($('.results-container').offset().top - 50)
                }
            })
            .then(parseJSON)
            .then(response => {
                this.setState({ year: Math.min(5, this.state.endAge-5-parseInt(this.startingAge.current.value)), showResults: true, conversionValue: response.response.conversion_value, rate: response.response.rate, totalYears: response.response.contract_length, isFetching: false })
                this.updateOffset()
                $(window).scrollTop($('.results-container').offset().top - 50)
                $('[data-toggle="tooltip"]').tooltip({ html: true })
            }).catch(e => {
                console.log(e)
                this.setState({ fetchError: 'Ekki var hægt að framkalla útreikning. Við bjóðum þér að hafa samband við okkur ef þú vilt skoða málið frekar með því að panta ráðgjöf.' })
                this.updateOffset()
                $(window).scrollTop($('.results-container').offset().top - 50)
            })

    }

    validate() {
        let valid = true;
        let errors = []
        if (this.startingAge.current.value === '' || parseInt(this.startingAge.current.value) < 18 || parseInt(this.startingAge.current.value) > 60) {
            errors.push('einstaklinga á aldrinum 18 til 60 ára')
            valid = false
        }
        if (this.state.startingSalary === '' || parseInt(this.state.startingSalary) < 100000) {
            errors.push('heildarlaun að lágmarki 100.000 krónur')
            valid = false
        }
        return [valid, errors]
    }

    calculate() {
        this.setState({ errors: [], fetchError: '', showResults: false }, () => {
            let [valid, errors] = this.validate()
            if (valid) {
                this.fetchData()
            } else {
                this.setState({ errors: errors }, () => {
                    $(window).scrollTop($('.results-container').offset().top - 50)
                })
                this.updateOffset()

            }
        })
    }

    updateOffset() {
        $('.follow').css(this.calculateOffset())
        $('.arrow').css(this.calculateArrowOffset())
    }

    calculateOffset() {
        let sliderWidth = $('.horizontal-slider').width()
        let ratio = this.state.year / (this.state.totalYears - 5)

        let startingPoint = ($('.results-container').width() - $('.horizontal-slider').width()) / 2

        let left = startingPoint + (ratio * (sliderWidth - $('.follow').width() - 40));

        if (left === NaN) {
            left = startingPoint
        }
        return { left: left }
    }

    calculateArrowOffset() {
        let containerWidth = $('.follow').width() - 12;
        return {
            left: `${6 + (this.state.year / (this.state.totalYears - 5)) * (containerWidth + 14)}px`
        }
    }


    calculateWaiting() {
        return this.state.rate * GESTable[this.state.totalYears - this.state.year] / GESTable[this.state.totalYears]
    }

    render() {

        const {
            image,
            highlightedWord,
            title,
            subtitle,
            startingAge
        } = this.props;

        const {
            showResults,
            isFetching,
            rate,
            year,
            totalYears,
            conversionValue,
            startingSalary,
        } = this.state;

        return (
            <>
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-12 outer-col" style={{ backgroundImage: `url(${image})` }}>
                        <div className="bg"></div>
                        <div className="col-12 text">
                            <div className="text-container">
                                <h2 className="title">{title}</h2>
                                {highlightedWord && <h2 className="highlight">{highlightedWord}</h2>}
                                <h3 className="subtitle">{subtitle}</h3>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-8 col-12 calculator d-flex">
                            <div className="input-container">
                                <div className="inner d-flex">
                                    <label htmlFor="age" className="mb-0">Aldur</label>
                                    <input type="tel" id="age" ref={this.startingAge} className="age mb-2 ml-auto" defaultValue={startingAge} />
                                    <span>ára</span>
                                </div>
                                <div className="inner d-flex">
                                    <label htmlFor="income" className="mb-0">Heildarlaun</label>
                                    <CurrencyFormat
                                        ref={this.startingSalary}
                                        thousandSeparator={"."}
                                        className="income ml-auto"
                                        id="income"
                                        type="tel"
                                        decimalSeparator={','}
                                        value={startingSalary}
                                        onValueChange={(values) => {
                                            const { value } = values;
                                            this.setState({ startingSalary: value })
                                        }}
                                    />

                                    <span>kr.</span>
                                </div>
                            </div>
                            <a href="#results-container" className="button d-flex align-items-center justify-content-center ml-auto calculate" onClick={() => this.calculate()}>
                                Reikna
                                {isFetching &&
                                    <>&nbsp; <Spinner /></>
                                }
                            </a>
                        </div>
                    </div>
                </div>
                {this.state.errors.length > 0 &&
                    <div className="results-container col-xl-8 col-12 mx-auto">
                        <div className="row">
                            <div className="offset-md-3 col-md-6 col-12 offset-0 text-center">
                                Þessi reiknivél birtir niðurstöðu fyrir &nbsp;
                                {this.state.errors.join(' og ')}. Við bjóðum þér að hafa samband við okkur ef þú vilt skoða málið frekar með því að panta ráðgjöf.
                            </div>
                        </div>
                        {this.props.buttonUrl &&
                            <div className="row align-items-center mt-5">
                                <div className="offset-md-4 col-md-4 col-12 offset-0 text-center">
                                    <a className="p-4 btn btn-primary d-flex align-items-center justify-content-center ml-auto " href={this.props.buttonUrl}>{this.props.buttonText}</a>
                                </div>
                            </div>
                        }
                    </div>

                }
                {this.state.fetchError !== '' &&
                    <div className="results-container col-xl-8 col-12 mx-auto">
                        <div className="row">
                            <div className="offset-md-3 col-md-6 col-12 offset-0 text-center mb-5">
                                <img src={window.images.myPagesEmpty} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="offset-md-3 col-md-6 col-12 offset-0 text-center">
                                {this.state.fetchError}
                            </div>
                        </div>
                        {this.props.buttonUrl &&
                            <div className="row align-items-center mt-5">
                                <div className="offset-md-3 col-md-6 col-12 offset-0 text-center">
                                    <a className="p-4 btn btn-primary d-flex align-items-center justify-content-center ml-auto " href={this.props.buttonUrl}>{this.props.buttonText}</a>
                                </div>
                            </div>
                        }
                    </div>

                }
                {showResults && !isFetching && rate !== null &&
                    <div className="results-container col-xl-8 col-12 mx-auto">
                        <div className="row">
                            <div className="col-md-3 offset-md-0 col-10 offset-1 offset-lg-0 card mr-sm-5 mb-sm-0 mb-5">
                                <span>Áætluð inneign við starfslok</span>
                                <h3 className="amount estimate">{formatMoney(rate)} kr.</h3>
                                <span>Ef þú byrjar í dag</span>
                            </div>
                            <div className="col-md-3 offset-md-0 col-10 offset-1 card mr-md-1 follow" style={this.calculateOffset()}>
                                <span>Áætluð inneign við starfslok</span>
                                <h3 className="amount">{formatMoney(this.calculateWaiting())} kr.</h3>
                                <span>
                                    {year > 0 ?
                                        <>Ef þú byrjar eftir {year} ár</>
                                        :
                                        <>Ef þú byrjar í dag</>
                                    }
                                </span>
                                <span className="arrow" style={this.calculateArrowOffset()}></span>
                            </div>
                        </div>
                        <div className="row justify-content-center ">
                            <div className="col-md-8 col-16 horizontal-slider-container">
                                <div className="slider text-center">
                                    <ReactSlider
                                        className="horizontal-slider"
                                        thumbClassName="slider-thumb"
                                        trackClassName="slider-track"
                                        min={1}
                                        max={Math.min(totalYears - 5, this.state.endAge-5-parseInt(this.startingAge.current.value))}
                                        value={year}
                                        onChange={(newVal, index) => {
                                            this.setState({ year: newVal })
                                        }}
                                        renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
                                    />

                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-5 col-10 text-center">
                                <span>Fórnarkostnaður þess að
                                    {year > 0 ?
                                        <>&nbsp;bíða í {year} ár</>
                                        :
                                        <>&nbsp;byrja í dag</>
                                    }
                                </span>
                                <h3 className="amount loss">{formatMoney(rate - this.calculateWaiting())} kr.</h3>
                                <div className="mt-3">
                                    <Tooltip className="asterisk mr-2" text={`${this.state.customTooltip}</p><p>Allir útreikningar eru framkvæmdir af reiknikerfum Allianz í Þýskalandi og taka ekki mið af verðbólgu- eða launaþróun.</p><p>Útreikningurinn er einungis til upplýsinga/hliðsjónar. \nHægt er að fá ítarlegri útreikninga hjá ráðgjöfum Allianz.</p><p><strong>Samningslok</strong> miða við 67 ára.</p><p><strong>Reiknað er með genginu</strong> 1€ = ${formatMoney(conversionValue, 2)} kr.<br/><strong>Dagsetning:</strong> ${moment.utc().format('D.M.YYYY')}</p>`} /> Forsendur útreikninga
                                </div>
                            </div>
                        </div>
                        {this.props.buttonUrl &&
                            <div className="row align-items-center mt-5">
                                <div className="col-md-4 offset-md-4 col-12 offset-0 text-center">
                                    <a className="p-4 btn btn-primary d-flex align-items-center justify-content-center ml-auto " href={this.props.buttonUrl}>{this.props.buttonText}</a>
                                </div>
                            </div>
                        }
                    </div>
                }
            </>
        )
    }
}

VidCalculatorPublic.defaultProps = {
    buttonUrl: null,
    buttonText: 'Panta ráðgjöf'
}

function mapStateToProps(state) {

    var f = {

    }


    return f;
}

export default connect(mapStateToProps)(VidCalculatorPublic);